module.exports = __webpack_public_path__ + "img/CuCiGlass01.c6228076.png";